import Device from "../../models/Device";

export function knxChapter_Keydown(device: Device, element: HTMLElement, ev: any, hasChildren: boolean) {
  const focusedElement = element;

  function getLastVisibleDescendant(chapter: HTMLElement): HTMLElement {
    let current = chapter;

    while (
      current.classList.contains("IsExpanded") // no itx
    ) {
      const childrenContainer = current.querySelector(
        ":scope > .knxChapterChildren", // no itx
      ) as HTMLElement | null;
      if (!childrenContainer) {
        break;
      }

      const childChapters = childrenContainer.querySelectorAll(":scope > .knxChapter");
      if (childChapters.length === 0) {
        break;
      }

      current = childChapters[childChapters.length - 1] as HTMLElement;
    }

    return current;
  }

  switch (ev.keyCode) {
    case 13:
      state.selectionManager.focusedObjectInNavigator?.treeViewModel?.handleOpen(true);
      break;

    case 40: //down
      ev.stopPropagation();
      ev.preventDefault();

      if (
        focusedElement?.classList.contains(
          "IsExpanded", // no itx
        ) &&
        hasChildren
      ) {
        const firstChildKxChapterElement = focusedElement.querySelector(".knxChapter") as HTMLElement; // no itx
        firstChildKxChapterElement?.focus();
      } else {
        const nextSibling = focusedElement.nextSibling;
        if (!nextSibling) {
          // no more nodes on this level.
          // we need to go one or more levels up and find the next node there
          let parent = focusedElement.parentElement?.closest(".knxChapter");
          while (parent) {
            const nextSibling = parent.nextSibling;
            if (nextSibling) {
              (nextSibling as HTMLElement)?.focus();
              break;
            }
            parent = parent?.parentElement?.closest(".knxChapter");
          }
        } else {
          (nextSibling as HTMLElement)?.focus();
        }
      }
      break;

    case 38: //up
      ev.stopPropagation();
      ev.preventDefault();

      const previousSibling = focusedElement.previousSibling;
      if (previousSibling == undefined) {
        const parent = focusedElement.parentElement?.closest(".knxChapter") as HTMLElement | null;
        parent?.focus();
      } else {
        const previousSiblingElement = previousSibling as HTMLElement;
        const target = getLastVisibleDescendant(previousSiblingElement);
        target?.focus();
      }

      break;

    case 37: //LEFT
      ev.stopPropagation();
      ev.preventDefault();

      if (
        focusedElement.classList.contains("IsExpanded") // no itx
      ) {
        focusedElement.classList.remove("IsExpanded"); // no itx
      } else {
        // navigate to parent
        const p1 = focusedElement.parentNode;
        (p1 as HTMLElement)?.focus();
      }

      break;

    case 39: //right
      ev.stopPropagation();
      ev.preventDefault();

      focusedElement.classList.add("IsExpanded"); // no itx
      break;

    default:
    // logger.log("unused key: ", ev.keyCode);
  }
}
